export enum RelationToPatientCategory {
  FAMILY = 'Family',
  NON_FAMILY = 'Non-family',
}

export enum TaskCloseVoidReasons {
  CONTEMPLATIVE = 'Contemplative',
  DATA_NOT_ENTERED = 'Data not entered',
  DECLINED_ADMIN_EQUIP_DELAY = 'Declined - Admin/Equip delay',
  DECLINED_CHOSE_HLOC = 'Declined - Chose HLOC (IOP/PHP/RTC)',
  DECLINED_CHOSE_NEW_OUTPUT_TEAM = 'Declined - Chose new output team',
  DECLINED_CONTINUE_CURRENT_TEAM = 'Declined - Continue with current team',
  DECLINED_UNKNOWN_TX_CHOICE = 'Declined - Unknown tx choice',
  MIA_LOST_CONTACT = 'MIA - Lost contact',
  MIA_NO_CONTACT = 'MIA - No contact',
  NOT_ELIGIBLE_WRONG_AGE = 'Not eligible - Wrong age',
  NOT_ELIGIBLE_WRONG_STATE = 'Not eligible - Wrong state',
  NOT_QUALIFIED_EQUIP_REF_CLINICAL_HLOC = 'Not qualified - Equip referred to clinical HLOC',
  NOT_QUALIFIED_EQUIP_REF_MEDICAL_HLOC = 'Not qualified - Equip referred to medical HLOC',
  NOT_QUALIFIED_FAMILY_UNWILLING = 'Not qualified - Family unwilling to participate in tx',
  NOT_QUALIFIED_FINANCIAL_CANT_AFFORD_OOP = 'Not qualified - Financial - Can’t afford OOP $',
  NOT_QUALIFIED_FINANCIAL_NOT_IN_NETWORK = 'Not qualified - Financial - Insurance not in-network',
  NOT_QUALIFIED_NO_EATING_DISORDER = 'Not qualified - No eating disorder',
  NOT_QUALIFIED_NOT_LIVING_WITH_FAMILY = 'Not qualified - Not living with family',
  ADMIN_EPISODE_CLOSED = 'Admin episode closed',
  ASSESSMENT_DELETED_OR_INCOMPLETE = 'Assessment deleted or incomplete',
  DUPLICATE = 'Duplicate',
  INQUIRY_CLOSED = 'Inquiry closed',
  MADE_IN_ERROR = 'Made in error',
}

export enum ValidationType {
  CRITICAL = 'critical',
  NEUTRAL = 'neutral',
  SUCCESS = 'success',
}
